import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { Testimony } from '../data/testimonies';
interface TestimonialCardProps {
  testimony: Testimony;
}
export function TestimonialCard({
  testimony
}: TestimonialCardProps) {
  return <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-soft flex flex-col h-full" data-id="element-174">
      <Quote size={28} strokeWidth={1} className="text-rose-600 mb-5" aria-hidden="true" data-id="element-175" />
      <p className="font-serif text-charcoal text-lg leading-relaxed italic mb-6 flex-grow" data-id="element-176">
        "{testimony.excerpt}"
      </p>
      <div className="border-t border-cream-200 pt-5 flex items-center justify-between" data-id="element-177">
        <div data-id="element-178">
          <p className="font-serif text-charcoal text-lg leading-tight" data-id="element-179">
            {testimony.name}
          </p>
          {testimony.location && <p className="text-xs text-charcoal-50 tracking-wide mt-0.5" data-id="element-180">
              {testimony.location}
            </p>}
        </div>
        <Link to={`/testimonies#${testimony.id}`} className="inline-flex items-center text-sm text-sage-700 hover:text-sage-600 transition-colors group" data-id="element-181">
          Read more
          <ArrowRight size={14} strokeWidth={1.5} className="ml-1.5 transform group-hover:translate-x-0.5 transition-transform" data-id="element-182" />
        </Link>
      </div>
    </div>;
}